


















































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import TextfieldEditor from '@/components/TextfieldEditor.vue';
import LanguagesDropDown from '@/components/DropDowns/LanguagesDropDown.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component({
    computed: {
        ...mapGetters({
            currentEditInquiry: 'TicketAttributes/getCurrentEditInquiry',
        }),
    },
    components: {
        TextfieldEditor,
        LanguagesDropDown,
    },
})
export default class EditInquiry extends Mixins(TicketHelper, InputFieldMethods, NotifyMethods) {
    public languages: any = [];
    public inquiryTitles: any = [];
    public inquiryMessages: any = [];
    public currentLanguage = 'en';

    constructor() {
        super();
    }

    public setTranslatableFields(languages: any) {
        languages.forEach((language: any) => {
            this.addTranslation(language);
        });
    }

    public addTranslation(addedLanguage: any) {
        const inquiry      = this.$store.getters['TicketAttributes/getCurrentEditInquiry'];
        const content      = inquiry.translations.find((translation: any) => translation.language_id === addedLanguage.id);
        const answerObject = inquiry.answers.find((answerRow: any) => answerRow.language_id === addedLanguage.id);

        const checkIfExist = this.inquiryTitles.find((title: any) => title.lang === addedLanguage.key);

        if (typeof checkIfExist === 'undefined') {
            this.inquiryTitles.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.description });
            this.inquiryMessages.push({ lang: addedLanguage.key, content: typeof answerObject === 'undefined' ? '' : answerObject.answer });
        }
    }

    public removeTranslation(deletedLanguage: any) {
        this.inquiryTitles   = this.inquiryTitles.filter((title: any) => title.lang !== deletedLanguage.key);
        this.inquiryMessages = this.inquiryMessages.filter((title: any) => title.lang !== deletedLanguage.key);
    }

    public setCurrentLanguage(selectedLanguage: any) {
        this.currentLanguage = selectedLanguage.key;
    }

    public deleteInquiry(inquiryId: number) {
        const inquiry = this.$store.getters['TicketAttributes/getCurrentEditInquiry'];

        this.$store.dispatch(Actions.DELETE_INQUIRY, {
            inquiryId,
            typeId: inquiry.type_id,
            categoryId: inquiry.category_id,
            projectId: inquiry.project_id,
        });
    }

    public editInquiry() {
        const inquiry = this.$store.getters['TicketAttributes/getCurrentEditInquiry'];

        if (!this.inquiryMessages.length || typeof this.inquiryMessages.find((title: any) => title.content.trim() === '') !== 'undefined') {
            return this.notify('please_fill_message_field', 'warning');
        }

        this.$validator.validate()
            .then((valid) => {
                if (valid) {
                    this.$store.dispatch(Actions.EDIT_INQUIRY, {
                        id: inquiry.id,
                        titles: this.inquiryTitles,
                        answers: this.inquiryMessages,
                        allow: inquiry.allow_contact,
                        typeId: inquiry.type_id,
                        priority: inquiry.priority,
                        categoryId: inquiry.category_id,
                        projectId: inquiry.project_id,
                    });
                }
            });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_EDIT_INQUIRY_VISIBILITY, false);
    }

    public setEditInqueryMessage(message: any) {
        const newInquiryMessage = this.inquiryMessages.find((newMessage: any) => newMessage.lang === this.currentLanguage);
        newInquiryMessage.content = message;
    }

    public created() {
        const inquiry = this.$store.getters['TicketAttributes/getCurrentEditInquiry'];
        this.languages = inquiry.translations.map((translation: any) => translation.language_id);
    }
}
